import { Injectable, OnInit } from '@angular/core';
import { UserService } from 'src/modules/user.service';
import { filter, map } from 'rxjs/operators';
import { RolePermission, TprecmUserProfile } from 'src/modules/api/tprecm-api.interface';
import { Observable } from 'rxjs';

const DEFAULT_PERMISSION = {
   read: false,
   write: false
};

@Injectable()
export class TprecmAuthorizationService {
   private _userRoleId: number = null;
   private _authorization: RolePermission;
   private _fieldPermissions: [string];

   constructor(
      private readonly userService: UserService
   ) {
      this.userService.userProfile
         .pipe(filter(Boolean))
         .subscribe((userProfile: any) => this._userRoleId = userProfile.userRoleId);


      this.userService.getUserFieldPermissions()
         .then(fields => this._fieldPermissions = fields);
   }

   public userRoleId(): Observable<number> {
      return this.userService.userProfile
         .pipe(
            filter(Boolean),
            map((profile: TprecmUserProfile) => profile.userRoleId)
         );
   }

   public tprFieldFullAccess() {
      return this.userRoleId()
         .pipe(map(id => id <= 4));
   }

   public getAuthorizationByField(field: string) {
      const permissions = this._fieldPermissions;
      return !permissions || permissions.indexOf(field) !== -1;
   }

   public async getRolePermissions() {
      if (!this._authorization) {
         this._authorization = await this.userService.getUserPermissions();
      }

      return this._authorization;
   }

   public async getAuthorizationByFeaturePermission(feature: string, permission: string | [string]) {
      const permissions = await this.getRolePermissions();
      const featurePermissions = permissions[feature];

      const allowed: [string] = typeof permission === 'string' ? [permission] : permission;

      if (!this._userRoleId) {
         return false;
      } else if (this._userRoleId === 1) { // SUPER USER
         return true;
      }



      if (!featurePermissions) {
         return DEFAULT_PERMISSION.read;
      }

      return allowed.some(p => (featurePermissions.subfeature[p] || DEFAULT_PERMISSION).write || (featurePermissions.subfeature[p] || DEFAULT_PERMISSION).read);
   }
}